import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { CardController } from 'src/app/shared/card.controller';
import { TourItineraryDateAgeBandConfig } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-age-band-config';
import { TourItineraryDatePaxConfig } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-pax-config';

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	getAgeBandTag: (item: AgeBandItem) => string;
	onChangeAgeBandValidity: (value: boolean) => void;
	onChangeOccupancyValidity: (value: boolean) => void;
}

interface State {
	invalidOccupancies: Set<string>;
}

@observer
export class TourItineraryDatePaxTab extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			invalidOccupancies: new Set<string>()
		};
	}

	@autobind
	private ensureOccupancyConstraints(newPaxPerBooking?: number): void {
		const { model, getAgeBandTag, onChangeOccupancyValidity } = this.props;
		const ageBands: AgeBandItem[] = model.dynamicProperties.ageBands;
		const paxConfig: ItineraryDatePaxConfig = model.dynamicProperties.paxConfig;

		const maxPaxPerBooking = newPaxPerBooking || paxConfig.maxPaxPerBooking;
		const storedOccupancies = new Set<string>();
		const newInvalidOccupancies = new Set<string>();
		for (let occupancy of paxConfig.occupancies) {
			['a', 'c', 'i'] // TODO: hardcoded
				.filter(m => ageBands.every(p => getAgeBandTag(p) !== m))
				.forEach((m) => {
					delete occupancy[m];
				});
			let paxesCount = 0;
			for (let ageBand of ageBands) {
				const tag = getAgeBandTag(ageBand);
				if (!(tag in occupancy)) {
					occupancy[tag] = '0';
				}

				paxesCount += parseInt(occupancy[tag]);
			}

			if (paxesCount === 0 || paxesCount > maxPaxPerBooking) {
				newInvalidOccupancies.add(occupancy.id);
				continue;
			}

			const hash = ageBands
				.map(m => occupancy[getAgeBandTag(m)])
				.join('-');
			if (!storedOccupancies.has(hash)) {
				storedOccupancies.add(hash);
			} else {
				newInvalidOccupancies.add(occupancy.id);
			}
		}

		const { invalidOccupancies } = this.state;
		const isSubset = Array.from(newInvalidOccupancies.keys()).every(m => invalidOccupancies.has(m));
		const isSuperset = Array.from(invalidOccupancies.keys()).every(m => newInvalidOccupancies.has(m));
		if (!isSubset || !isSuperset) {
			this.setState({
				invalidOccupancies: newInvalidOccupancies
			});
		}
		onChangeOccupancyValidity(newInvalidOccupancies.size === 0);
	}

	render(): React.ReactNode {
		const { mode } = this.props;
		const { invalidOccupancies } = this.state;

		return (
			<Row gutter={16}>
				<Col xs={24} md={12}>
					<CardController
						title="Age Bands"
						icon="team"
						className="card-borderless"
						mode={mode}>
						<TourItineraryDateAgeBandConfig
							ensureOccupancyConstraints={this.ensureOccupancyConstraints}
							{...this.props}
						/>
					</CardController>
				</Col>
				<Col xs={24} md={12}>
					<CardController
						title="Paxes"
						icon="team"
						className="card-borderless"
						mode={mode}>
						<TourItineraryDatePaxConfig
							invalidOccupancies={invalidOccupancies}
							ensureOccupancyConstraints={this.ensureOccupancyConstraints}
							{...this.props}
						/>
					</CardController>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-pax-tab.tsx